const ketToLetter = (v) => {
    const iterations = Math.max(1, (v / 26));
    let str = '';
    for (let i = 0; i < iterations; i++) {
        str += String.fromCharCode(97 + v);
    }
    return str.toUpperCase();
};
export { ketToLetter };
export default ketToLetter;
